export const INITIAL_CONTENT = {
  title: 'Confirm your action',
  question: 'Are you sure?',
  subQuestion: null,
  noLabel: 'NO',
  yesLabel: 'YES',
  renderContent: () => null,
};
